<!-- Begin Page Content -->
<div class="container-fluid">
  <div>
    <!-- <div class="card-header py-3 bg-white">
      <h1 class="text-gray-800" style="display: inline-block">
        Manage Event Logs
      </h1>
      <button
        type="button"
        class="btn"
        style="float: right"
        [routerLink]="['/component', 'eventlogs', 'add-eventlogs']"
      >
        Add Event Logs
      </button>
    </div> -->
 
    <div>
      <div class="col-6">
          <!-- Commented on 20th April 2026 for the breadcrumb changes -->
        <!--<label for="name" class="form-label">Plant:</label>
        <select
          class="form-control border border-dark"
          name="plantid"
          [(ngModel)]="selectedPlantId"
          (change)="getSelectedId($event)"
        >
          <option value="">Select Plant</option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
        </select> !-->




        <!-- <select
          class="form-select border border-dark"
          name="plantid"
          (change)="getSelectedId($event)"
        >
          <option [selected]>Select Plant</option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
        </select> -->


        
      </div>
 
      <div class="col-6">
        
     <!-- Commented on 20th april 2026 for the breadcrumb changes -->
       <!-- <label for="train" class="form-label">Train:</label>
         <select
          class="form-control border border-dark"
          name="trainid"
          [(ngModel)]="selectedTrainId"
          (change)="getSelectedTrainId($event)"
        >
          <option value="">Select Train</option>
          <option *ngFor="let train of trains" [value]="train.Id">
            {{ train.Name }}
          </option>
        </select> -->



 <!-- Commented on 20th april 2026 for the breadcrumb changes -->
        <!-- <select
          class="form-select border border-dark"
          name="trainid"
          (change)="getSelectedTrainId($event)"
        >
        <option [selected]>Select Train</option>
          <option *ngFor="let train of trains" [value]="train.Id">
            {{ train.Name }}
          </option>
        </select> -->

   
      </div>
        <!-- <div class="col-md-2">
        <label class="form-label">&nbsp;</label>
        <button
          type="button"
          class="btn btn-block mt-2"
          (click)="clearFilters()"
          [disabled]="!selectedPlantId && !selectedTrainId"
          title="Clear selected Plant and Train">
          <i class="fas fa-times"></i> Clear
        </button>
      </div> -->
    </div>
 
    <br />
 
    <div style="min-height: 20px"></div>
    <div id="dvRaw">
      <table
        datatable
        [dtOptions]="dtoptions"
        class="table table-bordered"
        width="100%"
        *ngIf="eventlogs && eventlogs.length > 0"
      >
        <thead>
          <tr>
            <th>Project / Train</th>
            <th>Date / Time</th>
            <th>Type</th>
          </tr>
        </thead>
 
        <tbody>
          <tr *ngFor="let eventlog of eventlogs">
            <td>
              <a style="color: black" (click)="navigate(eventlog.Id)"
                >{{ plantDetails.Name }} / {{ trainDetails.Name }}</a
              >
            </td>
            <td>
              <a style="color: black" (click)="navigate(eventlog.Id)">{{
                eventlog.Datetime
              }}</a>
            </td>
            <td>
              <a style="color: black" (click)="navigate(eventlog.Id)">{{
                eventlog.EventType
              }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div style="min-height: 100px"></div>
 
 